<template>

  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>


  <div class="cell small-12">
      <h1>Contract</h1>
      <p>We have prepared a contract for your company, please select or provide the contract signatory.</p>
    </div>

    <div class="cell small-12">
      <form @submit.prevent>
        <div id="signatories-significant-control">
        <label v-for="(contact, idx) in localContacts" :key="idx" class="radio-label custom-check">
          <input type="radio" :value="'Person ' + idx" name="signatory" />
          {{ contact.firstName + " " + contact.lastName }} 
          <span class="radiomark"></span>
        </label>
        </div>
      </form>
    </div>


    <div class="cell small-8">
      <form @submit.prevent>
      <br/>
      <label class="custom-check">
             <input type="checkbox" v-model="isCustomSignatory">The contract signatory is not listed, I want to provide their details
            <span class="checkmark"></span>
        </label>
        <br/>
        <div v-if="isCustomSignatory" class="custom-signatory-fields">
          <label>
            Forename
            <input type="text" v-model="customSignatoryObject.forename" />
          </label>
          <label>
            Surname
            <input type="text" v-model="customSignatoryObject.surname" />
          </label>
          <label>
            Job Title
            <input type="text" v-model="customSignatoryObject.jobTitle" />
          </label>
          <label>
            Email Address
            <input type="email" v-model="customSignatoryObject.email" />
          </label>
        </div>
        </form>
    </div>


</template>


<script setup>

import { ref, watch, defineEmits, reactive, onMounted } from 'vue'
import { useRoute } from 'vue-router';

const error = ref([])
const route = useRoute();
const signupId = route.params.signupId;

const isCustomSignatory = ref(false)
const customSignatoryObject = reactive({
  forename: '',
  surname: '',
  jobTitle: '',
  email: '',
  isVerificationRequired: false
})

const props = defineProps({
  formData: Object,
  clientInvite: Object
})

const localContacts = ref([]);

onMounted(() => {
  localContacts.value = props.formData.contacts ? [...props.formData.contacts] : [];
});


watch(isCustomSignatory, (newValue) => {
  const radioButtons = document.querySelectorAll('#signatories-significant-control input[type="radio"]');
  radioButtons.forEach(radio => {
    radio.disabled = newValue;
    radio.checked = false;
  });
});

const validateStep = () => {
  error.value = [];

  if (isCustomSignatory.value) {
    const firstName = customSignatoryObject.forename?.trim() || '';
    const lastName = customSignatoryObject.surname?.trim() || '';
    const jobTitle = customSignatoryObject.jobTitle?.trim() || '';
    const email = customSignatoryObject.email?.trim() || '';

    // FirstName: Required, MaxLength(50)
    if (!firstName) {
      error.value.push('First name is required.');
    } else if (firstName.length > 50) {
      error.value.push('First name cannot exceed 50 characters.');
    }

    // LastName: Required, MaxLength(50)
    if (!lastName) {
      error.value.push('Last name is required.');
    } else if (lastName.length > 50) {
      error.value.push('Last name cannot exceed 50 characters.');
    }

    // JobTitle: Required, MaxLength(50)
    if (!jobTitle) {
      error.value.push('Job title is required.');
    } else if (jobTitle.length > 50) {
      error.value.push('Job title cannot exceed 50 characters.');
    }

    // Email: Required, MaxLength(256), EmailAddress
    if (!email) {
      error.value.push('Email address is required.');
    } else if (email.length > 256) {
      error.value.push('Email address cannot exceed 256 characters.');
    } else {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailPattern.test(email)) {
        error.value.push('Please enter a valid email address.');
      }
    }

    return error.value.length === 0;
  }

  const radios = document.querySelectorAll(
    '#signatories-significant-control input[type="radio"]'
  );

  const checked = Array.from(radios).some(radio => radio.checked);

  if (!checked) {
    error.value.push('Please select a contract signatory.');
    return false;
  }

  return true;
};
const emit = defineEmits(['update-form']);
const executeStep = async () => {

  signatoryMapper();

  return true;
}

const signatoryMapper = () => {

  let emitObject = { ...props.formData };

  if (isCustomSignatory.value) {

    const customContact = {
      firstName: customSignatoryObject.forename,
      lastName: customSignatoryObject.surname,
      jobTitle: customSignatoryObject.jobTitle,
      email: customSignatoryObject.email,
      isVerificationRequired: false,
      isSlaSignatory: true,
      isDirectDebitAuthoriser: false
    };

    emitObject.contacts = [...(props.formData.contacts || []), customContact];
  } else {
    const radios = document.querySelectorAll('#signatories-significant-control input[type="radio"]');
    let selectedIdx = null;
    radios.forEach((radio, idx) => {
      if (radio.checked) selectedIdx = idx;
    });
    if (selectedIdx !== null && props.formData.contacts && props.formData.contacts[selectedIdx]) {
      const selectedContact = { ...props.formData.contacts[selectedIdx], isSlaSignatory: true };
      emitObject.contacts = props.formData.contacts.map((c, i) =>
        i === selectedIdx ? selectedContact : { ...c, isSlaSignatory: false }
      );
    }
  }

  emit('update-form', emitObject);
  return emitObject;
}


defineExpose({ validateStep, executeStep });

</script>